var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('affiliate-invoices-wrap',{attrs:{"title":"Партнёрские счета","api-method-invoices":_vm.getAffiliateInvoices,"api-method-invoices-summary":_vm.getAffiliateInvoicesSummary,"filters":_vm.filters,"columns":_vm.columns,"transform-submited-params":_vm.transformParamsObjBeforeSubmit,"table-headers":_vm.tableHeaders}})
}
var staticRenderFns = []

export { render, staticRenderFns }